<template>
  <div class="flex flex-col items-center px-3 py-4 sm:px-1 sm:py-0 xs:pt-0">
    <h2
      v-ui-test-name="'authModalTitle'"
      :class="[
        'mb-8 text-center font-flex-bold text-2xl font-bold',
        'sm:text-left sm:text-lg',
        'xs:-mx-5 xs:mb-5 xs:border-b xs:border-b-neutral-50 xs:px-5 xs:pb-4',
      ]"
    >
      Вход в профиль
    </h2>
    <AuthenticationAttemptForm class="grow" />

    <div
      v-if="!hideOAuth && !isSocialAuthEmpty"
      class="mt-6 w-full border-t border-neutral-100 pt-6 text-center"
    >
      Или с помощью аккаунта
      <SocialNetworkAuth class="mt-4 justify-center" />
    </div>
    <AnalyticsEventWrapper
      v-slot="{ analyticsHandler }"
      event="open_registration_screen"
      yandex-metrika
      :event-value="{ placement: 'Личный кабинет-всплывающее окно' }"
      class="mt-6 w-full border-t border-neutral-100 pt-6 text-center"
    >
      <UiButton
        v-ui-test-name="'registrationButton'"
        underline
        @click="clickRegistration(analyticsHandler)"
      >
        Зарегистрироваться
      </UiButton>
    </AnalyticsEventWrapper>
    <span class="mt-8 text-sm">
      Регистрируясь и авторизуясь, вы подтверждаете, что ознакомлены и согласны
      с условиями
      <a
        class="select-none underline underline-offset-1"
        target="_blank"
        :href="getAbsoluteLink('/pages/oferta')"
      >
        Публичной оферты
      </a>
      и
      <a
        class="select-none underline underline-offset-1"
        target="_blank"
        :href="getAbsoluteLink('/pages/privacy')"
      >
        Политики конфиденциальности
      </a>
    </span>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  hideOAuth: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const { openRegistrationModal } = useRegistrationStore()
const { closeModal } = useModalStore()
const { isSocialAuthEmpty } = storeToRefs(useLayoutStore())
const { getAbsoluteLink } = useLocationStore()
const clickRegistration = (analyticsHandler: () => void) => {
  closeModal('authenticationAttemptFormModal')

  openRegistrationModal(props.hideOAuth)
  analyticsHandler()
}
</script>
